import * as React from 'react';

/**
 * Provides mouse-over / mouse-out handlers that trigger a callback
 * after a short delay. Optionally delays all interactions for a
 * specified duration after mount (e.g. to avoid accidental hovers
 * during page load).
 */
export const useDelayedHover = (onChange: (index: number) => void) => {
  const hoverTimeoutRef = React.useRef<ReturnType<typeof setTimeout> | null>(
    null
  );

  const handleMouseOver = React.useCallback(
    (index: number) => {
      hoverTimeoutRef.current = setTimeout(() => {
        onChange(index);
      }, 150);
    },
    [onChange]
  );

  const handleMouseOut = React.useCallback(() => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
  }, []);

  React.useEffect(() => {
    return () => {
      if (hoverTimeoutRef.current) {
        clearTimeout(hoverTimeoutRef.current);
      }
    };
  }, []);

  return { handleMouseOver, handleMouseOut };
};
